import { faBell, faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Modal = ({ mostrar, onClose }) => {
    if (!mostrar) {
        return null;
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-3xl shadow-2xl w-11/12 md:w-1/3 lg:w-1/4 p-8 transform transition-transform duration-300 ease-in-out scale-105">
                <div className="flex justify-end">
                    <button
                        className="text-gray-400 hover:text-gray-600 transition duration-300"
                        onClick={onClose}
                    >
                        <FontAwesomeIcon icon={faTimes} className="text-2xl" />
                    </button>
                </div>
                <div className="text-center">
                    <FontAwesomeIcon icon={faBell} className="text-purple-800 text-6xl mb-6 animate-bounce" />
                    <h2 className="text-3xl font-bold mb-4">No se encontraron propiedades</h2>
                    <p className="text-gray-600 mb-6">¿Te gustaría crear una alerta para esta búsqueda y recibir notificaciones cuando haya nuevas propiedades disponibles?</p>
                    <div className="flex justify-center space-x-4">
                        <button
                            className="text-sm bg-gradient-to-r from-cyan-300 via-cyan-400 to-cyan-500 text-white font-bold py-3 px-6 rounded-full flex items-center space-x-2 transition duration-300 transform hover:scale-110"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faCheck} className="text-lg" />
                            <span>Sí</span>
                        </button>
                        <button
                            className="text-sm bg-gradient-to-r from-gray-500 to-gray-700 hover:from-gray-700 hover:to-gray-900 text-white font-bold py-3 px-6 rounded-full flex items-center space-x-2 transition duration-300 transform hover:scale-110"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faTimes} className="text-lg" />
                            <span>No</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
